import {mapGetters} from "vuex";

export default {
	computed:{
		...mapGetters('search', ['config']),
		layout(){
			return this.config?.layout || {};
		}
	}
}
